import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {PromoPhotosDataGrid} from './components/PromoPhotosDataGrid';

export function PromoPhotos() {
  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.salesSettings.labels.promotionalPhotos'),
          i18n.t('page.salesSettings.labels.advertising'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        header={{
          title: i18n.t('page.salesSettings.labels.promotionalPhotos'),
          breadcrumbs: [
            {
              label: i18n.t('page.salesSettings.labels.advertising'),
              href: settingsRoutes.advertising,
            },
          ],
        }}
        description={i18n.t('page.salesSettings.labels.promotionalPhotosDescription')}
        data-testid="settings-advertising-promoPhotos"
      >
        <PromoPhotosDataGrid />
      </SettingsTemplate>
    </>
  );
}
